import { ProductType } from './products.model';

export interface NewsletterData {
  email?: string;
  name?: string;
  fields?: {
    phone?: string;
    zip?: string;
    cid?: string;
    product?: ProductType;
    grant?: string;
  };
}

// export enum NewsletterList {
//   Dotacje = 105914146,
//   Instalatorzy = 105588955,
//   Newsletter = 105629134,
//   Partnerzy = 105622315,
//   Szkolenia = 105626584
// }


export enum NewsletterList {
  Dotacje = 'Dotacje',
  Instalatorzy = 'Instalatorzy',
  Newsletter = 'Newsletter',
  Partnerzy = 'Partnerzy',
  Szkolenia = 'Szkolenia'
}
